<template>
<ItpBox
  direction="column"
  class="job__job-runs overflow-hidden h-100"
>
  <JobRunView
    :item="item.runs[0]"
    v-if="item.runs && item.runs.length === 1"
  >
  </JobRunView>
  <BCard
    no-body
    class="overflow-hidden"
    v-if="item.runs && item.runs.length > 1"
  >
    <BTabs
      card
      v-if="item.runs && item.runs.length"
    >
      <BTab
        :key="run.id"
        class="overflow-hidden h-100"
        v-for="run in item.runs"
      >
        <template
          slot="title"
        >
          <ItpText
            :text="'#' + run.run_number"
          >
          </ItpText>
          <UcStatusBadge
            :status="run.status"
          >
          </UcStatusBadge>
        </template>
        <JobRunView
          :item="run"
        >
        </JobRunView>
      </BTab>
    </BTabs>
  </BCard>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobRuns extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("JobRuns", JobRuns);

</script>